<template>
  <div v-if="errorMessages.length > 0" class="rounded-md bg-red-50 dark:bg-red-950 p-4 mb-4">
    <div class="flex">
      <div class="shrink-0">
        <svg class="h-5 w-5 text-red-400 dark:text-red-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800 dark:text-red-400">
          Please fix the following {{ errorMessages.length === 1 ? 'error' : `${errorMessages.length} errors` }} to continue
        </h3>
        <div class="mt-2 text-sm text-red-700 dark:text-red-300">
          <ul class="list-disc pl-5 space-y-1">
            <li v-for="(msg, index) in errorMessages" :key="index">{{ msg }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const fieldLabels: Record<string, string> = {
    'First_Name__c': 'First Name',
    'Last_Name__c': 'Last Name',
    'LandLine__c': 'Landline Phone',
    'Nick_name__c': 'Nickname',
    'alternate_contact_no__c': 'Alternative Contact Number',
    'DoB__c': 'Date of Birth',
    'eMail__c': 'Email',
    'SkypeID__c': 'Skype',
    'phadd__c': 'Home Address',
    'phicity1__c': 'Home City',
    'PhilState__c': 'Home Province/State',
    'Hzip__c': 'Home Postal Code',
    'phvill__c': 'Home Village/Town',
    'hprovince__c': 'Home Province',
    'hcontry__c': 'Home Country',
    'pmadd__c': 'Mailing Address',
    'Phicity1x__c': 'Mailing City',
    'PhilStatex__c': 'Mailing Province/State',
    'Mzip__c': 'Mailing Postal Code',
    'pmvill__c': 'Mailing Village/Town',
    'mprovince__c': 'Mailing Province',
    'Mcountry__c': 'Mailing Country',
    'Institut__c': 'Institution',
    'YRGraduated__c': 'Year Graduated',
    'Degree__c': 'Degree',
    'CourseTaken__c': 'Courses Taken',
    'sssno__c': 'SSS Number',
    'TIN__c': 'Tax Identification Number',
    'PAGibigno__c': 'PhilHealth Number',
    'emcontact__c': 'Emergency Contact Name',
    'emmob__c': 'Emergency Contact Mobile',
    'emrelat__c': 'Emergency Contact Relationship',
    'emland__c': 'Emergency Contact Landline',
    'emadd__c': 'Emergency Contact Address',
    'MSoffice__c': 'Microsoft Office Skills',
    'Adobe__c': 'Adobe Photoshop Skills',
    'Webdev__c': 'Web Development Skills',
    'Graphicdesign__c': 'Graphic Design Skills',
    'vedit__c': 'Video Editing Skills',
    'Others__c': 'Other Skills',
    'Is_it_ok_to_work_on_week_ends__c': 'Available to Work Weekends',
  };

  const props = defineProps<{
    errors: Record<string, string | string[]> | string[];
  }>();

  const errorMessages = computed(() => {
    const messages: string[] = [];

    // Handle string[] format (e.g. ['Error message 1', 'Error message 2'])
    if (Array.isArray(props.errors)) {
      return props.errors;
    }

    for (const [field, fieldErrors] of Object.entries(props.errors)) {
      const label = fieldLabels[field];
      const errorList = Array.isArray(fieldErrors) ? fieldErrors : [fieldErrors];
      for (const error of errorList) {
        messages.push(label ? `${label}: ${error}` : error);
      }
    }
    return messages;
  });
</script>
